import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import preferences from './preferences/reducer';
import people from './people/reducer';
import groups from './groups/reducer';
import auth from './auth/reducer';
import intl from './intl/reducer';
import user from './user/reducer';

export default history =>
  combineReducers({
    router: connectRouter(history),
    preferences,
    people,
    groups,
    auth,
    intl,
    user
  });
